import React from 'react';
import { Grid, Typography, Box, useTheme } from '@mui/material';
import { DmsAltBox } from 'dmsbasereact';

export const SummaryCards = ({ summaryCards }) => {
    const theme = useTheme();

    return (
        <Grid container spacing={2}>
            {summaryCards.map((card) => (
                <Grid item xs={12} sm={6} md={3} key={card.key}>
                    <DmsAltBox.Card
                        data-testid={card.testId}
                        sx={{
                            height: '100%',
                            borderTop: `3px solid ${theme.palette.primary.main}`
                        }}
                    >
                        <DmsAltBox.Body>
                            <Box sx={{ textAlign: 'center', py: 1 }}>
                                <Typography
                                    variant="overline"
                                    sx={{
                                        color: "text.secondary",
                                        display: 'block',
                                        lineHeight: 1.5
                                    }}
                                >
                                    {card.label}
                                </Typography>
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: 700,
                                        color: 'primary.main'
                                    }}
                                >
                                    {card.value}
                                </Typography>
                            </Box>
                        </DmsAltBox.Body>
                    </DmsAltBox.Card>
                </Grid>
            ))}
        </Grid>
    );
};
